// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__RPkGy","open":"Modal_open__4qPj-","modal":"Modal_modal__qfa5n","top":"Modal_top__IWgRw","x":"Modal_x__hiF1F","child":"Modal_child__9kIbi"};